
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/store/authStore';
const GuestRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { isAuthenticated } = useAuth();
    const location = useLocation();

    // Si ya está autenticado, redirigir a donde venía o al home
    if (isAuthenticated) {
        const from = (location.state as any)?.from?.pathname || '/';
        return <Navigate to={from} replace />;
    }

    return <>{children}</>;
};



//export { ProtectedRoute, GuestRoute };
//export default ProtectedRoute;
export default GuestRoute;